import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidators {
  public static number(includeNegative = false) {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (value === null || value === undefined || value === '') {
        return null;
      }

      const regEx = includeNegative ? /^-?[0-9]+(\.[0-9]*)?$/ : /^[0-9]+(\.[0-9]*)?$/;

      if (!value.toString().match(regEx)) {
        if (!includeNegative && value.toString().startsWith('-')) {
          return { numeric: 'numericPositive' };
        }
        return { numeric: 'numeric' };
      }

      return null;
    };
  }

  public static exactLength(length: number) {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (value === null || value === undefined || value === '') {
        return null;
      }

      if (value.toString().length != length) {
        return { exactLength: length };
      }

      return null;
    };
  }

  public static customMessage(baseValidator: ValidatorFn, customKey: string) {
    return (control: AbstractControl): ValidationErrors | null => {
      const validationErrors = baseValidator(control);
      if (validationErrors) {
        return { customMessage: customKey };
      }
      return null;
    };
  }

  public static productProtectionValidator(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const productProtection = group.get('productProtection')?.value;
      const email = group.get('email')?.value;
      const phoneNumber = group.get('phoneNumber')?.value;

      if (productProtection && !email && !phoneNumber) {
        return { productProtectionRequired: true };
      }

      return null;
    };
  }

  public static containsText(text: string) {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value && typeof control.value === 'string') {
        return control.value.includes(text)
          ? null
          : {
              containsString: {
                requiredSubstring: text,
                actualValue: control.value,
              },
            };
      }
      return null;
    };
  }

  public static phoneNumber() {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      // Allow empty or null values (if the field is optional)
      if (!value) {
        return null;
      }

      // Ensure the value is a numeric string of exactly 10 digits
      const regEx = /^1\d{10}$/;
      if (typeof value !== 'string' || !regEx.test(value)) {
        return { phoneNumber: true }; // Validation error key
      }

      return null; // Valid input
    };
  }
}
